import React, { useState, useEffect } from 'react';
import { InputText, ImageUpload, InputTextArea, DropdownField } from '../../../common/input';
import BaseModalForm from '../../../common/modal/BaseModalForm';
import { iconOptions } from 'core/config/iconOptions';

const EditHistoryModal = ({ show, history, handleClose, handleSave, updating, errors }) => {
    const [updatedHistory, setUpdatedHistory] = useState(history);

    useEffect(() => {
        setUpdatedHistory(history);
    }, [history]);

    const handleChange = (key, value) => {
        setUpdatedHistory(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleSaveClick = () => {
        handleSave(updatedHistory);
    };

    return (
        <BaseModalForm
            show={show}
            title="Edit History"
            handleClose={handleClose}
            handleSave={handleSaveClick}
            updating={updating}
        >
            <div className="row">
                <div className="col-md-6">
                    <InputText
                        value={updatedHistory?.target}
                        onChange={(e) => handleChange('target', e.target.value)}
                        label="Identificador de la Historia"
                        error={errors?.target}
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        value={updatedHistory?.title}
                        onChange={(e) => handleChange('title', e.target.value)}
                        label="Title"
                        error={errors?.title}
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        value={updatedHistory?.subtitle}
                        onChange={(e) => handleChange('subtitle', e.target.value)}
                        label="Subtitle"
                        error={errors?.subtitle}
                    />
                </div>
                <div className="col-md-6">
                    <DropdownField
                        value={updatedHistory?.icon}
                        options={iconOptions}
                        onChange={(e) => handleChange('icon', e.value)}
                        placeholder="Seleccionar Ícono"
                        label="Icon"
                        error={errors?.icon}
                    />
                </div>
                <div className="col-md-12">
                    <InputTextArea
                        value={updatedHistory?.details}
                        onChange={(e) => handleChange('details', e.target.value)}
                        label="Details"
                        error={errors?.details}
                    />
                </div>
                <div className="col-md-12">
                    <ImageUpload
                        value={updatedHistory?.image}
                        onFileChange={(e) => handleChange('image', e.target.files[0])}
                        label="Image"
                        error={errors?.image}
                    />
                </div>
            </div>
        </BaseModalForm>
    );
};

export default EditHistoryModal;
